import React, { useState } from 'react';
import {
    Form,
    Input,
    Container,
    Spinner,
} from "reactstrap";
import { userforgotApi } from "../../doctorapi";
import { toast } from "react-toastify";
import { FullWrap, FormWrap, Heading, LoginButton } from "../Userlogin/styles";
import { useHistory } from "react-router-dom"
import get from "lodash/get";

const ForgotPassword = () => {
    const [userDetails, setUserDetails] = useState({
        email: "",
    })
    const [isLoading, setIsLoading] = useState(false);
    const Usersign = (e) => {
        setUserDetails({ ...userDetails, [e.target.name]: e.target.value })
    }
    let history = useHistory()
    const handlesubmit = () => {
        const data = {
            email: userDetails.email,
        }
        setIsLoading(true);
        userforgotApi(data).then(response => {
        setIsLoading(false);
            if (response.data.statusCode === 200) {
                toast.success("Reset password link has been sent to your email address")
                setUserDetails({
                    email: "",
                })
                history.push('/login')
            } else {
                toast.error(response.data.body.error.description || "something went wrong")
            }
        }).catch(error => {
            setIsLoading(false);
            const description = get(error, 'response.data.body.error.description', 'Something went wrong');
            toast.error(description);
        })
    }
    return (
        <FullWrap>
            <Container>
                <FormWrap>
                    <Form
                        action=""
                        className="form"
                        method=""
                        autoComplete="off">
                        <Heading>Forgot Password</Heading>
                        <Input
                            type="email"
                            name="email"
                            value={userDetails.email}
                            placeholder="Enter your email"
                            onChange={(e) => {
                                Usersign(e)
                            }}
                        />
                        <LoginButton
                            block
                            // href="#"
                            onClick={(e) => handlesubmit(e)}
                            disabled={!userDetails.email || isLoading}
                        >
                            { isLoading ?
                                 <Spinner
                                 as="span"
                                 animation="border"
                                 size="sm"
                                 role="status"
                                 aria-hidden="true"
                               />
                               : 'Submit'
                            }
                        </LoginButton>
                    </Form>
                </FormWrap>
            </Container>
        </FullWrap>
    );
};

export default ForgotPassword;


// WEBPACK FOOTER //
// ./src/component/UserForgotPassword/index.js